import { render, staticRenderFns } from "./NormalizedNamesList.vue?vue&type=template&id=6156c030"
import script from "./NormalizedNamesList.vue?vue&type=script&lang=js"
export * from "./NormalizedNamesList.vue?vue&type=script&lang=js"
import style0 from "./NormalizedNamesList.vue?vue&type=style&index=0&id=6156c030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports